import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Sort = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 20">
      <path d="M5.168,0.064c0.425,0 0.77,0.333 0.77,0.743l-0.001,16.655l3.037,-2.935c0.294,-0.284 0.765,-0.29 1.067,-0.02l0.02,0.02c0.294,0.283 0.3,0.74 0.02,1.03l-0.02,0.02l-4.35,4.205c-0.293,0.284 -0.764,0.29 -1.066,0.02l-0.02,-0.02l-4.35,-4.204c-0.3,-0.29 -0.3,-0.76 0,-1.051c0.293,-0.284 0.765,-0.29 1.066,-0.02l0.021,0.02l3.037,2.935l0,-16.655c0,-0.41 0.344,-0.743 0.77,-0.743l-0.001,0Zm14.232,0.131l0.024,0.023l4.35,4.204l0.02,0.02c0.273,0.284 0.274,0.723 0.003,1.008l-0.023,0.023l-0.02,0.02c-0.294,0.263 -0.748,0.264 -1.043,0.003l-0.024,-0.023l-3.037,-2.935l0,16.655c0,0.41 -0.345,0.743 -0.77,0.743c-0.424,0 -0.768,-0.333 -0.768,-0.743l0,-16.655l-3.037,2.935l-0.021,0.02c-0.302,0.27 -0.773,0.264 -1.067,-0.02c-0.292,-0.283 -0.3,-0.737 -0.022,-1.028l0.022,-0.023l4.35,-4.204l0.02,-0.02c0.286,-0.256 0.723,-0.264 1.018,-0.024l0.025,0.021Z" />
    </svg>
  );
};

Sort.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Sort;
